<qpx-avatar
    [colorKey]="identifier()"
    [imageUrl]="imageUrl()"
    [initials]="initials()"
    [fallbackIcon]="fallbackIcon()"
/>

<div class="content-container" [class.navigation]="context() === 'navigation'">
    <span class="content-line1">{{ line1() }}</span>
    @if (line2()) {
        <span class="content-line2">{{ line2() }}</span>
    }
</div>

<div class="action-container" [class.hidden!]="!hasContent()">
    <ng-content />
</div>
